import baseRequest  from '../baseRequest';
import AppConfig    from '../../app/config/AppConfig';

/* actions */
import * as Actions from '../../redux/actions';


class GetUserOrdersRequest extends baseRequest {

    constructor() {
        super();
        this.dispatch = null;
        this.response = null;
        this.name     = 'get list of user orders';
        this.Config   = new AppConfig();
    }

    execute(dispatch) {
        this.dispatch = dispatch;
        this.call(this.Config.api.requests.getUserOrders);
    }

    //Parse successful response
    onSuccess() {
        this.updateState();
    }

    //Dispatch actions to update redux state
    updateState() {
        this.dispatch(Actions.setUserOrders(this.response.data));
    }
}


export default GetUserOrdersRequest;